// Tenant namespace. Set REACT_APP_TENANT_ID per environment (.env / .env.test
// / .env.production). Falls back to 'sofibella' so existing builds are unchanged.
export const FIRESTORE_NAMESPACE = process.env.REACT_APP_TENANT_ID || 'sofibella';
export const FIRESTORE_COLLECTION_PREFIX = 'artifacts';

export function collectionPath(...segments) {
  // Usage: collectionPath('customers') => 'artifacts/{tenantId}/customers'
  return [FIRESTORE_COLLECTION_PREFIX, FIRESTORE_NAMESPACE, ...segments]
    .filter(Boolean)
    .join('/');
}
export function documentPath(...segments) {
  // Usage: documentPath('customers', customerId) => 'artifacts/{tenantId}/customers/customerId'
  return [FIRESTORE_COLLECTION_PREFIX, FIRESTORE_NAMESPACE, ...segments]
    .filter(Boolean)
    .join('/');
}
